import { useTranslations } from 'next-intl';
import ImageItemListSection, {
  ImageItemListItem,
} from './ImageItemListSection';

const getItems = (t: (key: string) => string): ImageItemListItem[] => [
  {
    id: 'collagen',
    title: t('photon.skinHealthSection.item.collagenSupport'),
    description: t('photon.skinHealthSection.item.collagenSupportDesc'),
  },
  {
    id: 'surface-recovery',
    title: t('photon.skinHealthSection.item.surfaceRecovery'),
    description: t('photon.skinHealthSection.item.surfaceRecoveryDesc'),
  },
  {
    id: 'tone-texture',
    title: t('photon.skinHealthSection.item.toneTexture'),
    description: t('photon.skinHealthSection.item.toneTextureDesc'),
  },
  {
    id: 'non-thermal',
    title: t('photon.skinHealthSection.item.nonThermal'),
    description: t('photon.skinHealthSection.item.nonThermalDesc'),
  },
];

const SkinHealthSection = () => {
  const t = useTranslations('photon');

  return (
    <ImageItemListSection
      eyebrow={t('photon.skinHealthSection.eyebrow.skinHealth')}
      heading={t('photon.skinHealthSection.heading.smootherSkin')}
      description={t('photon.skinHealthSection.description.reachesSkin')}
      items={getItems(t)}
      image="web_v2/photon/landing-page/skin-health-v2.png"
      imageAlt={t('photon.skinHealthSection.image.skinHealthAlt')}
      mediaSide="left"
    />
  );
};

export default SkinHealthSection;
